import React, { useState, useEffect, useRef } from "react";
import { Box, Button, Typography, IconButton } from "@mui/material";
import { useAuth } from "../../auth/AuthContext";
import LoadingPage from "../../Loader";
import Carousels from "./Carousels";
import News from "./News";
import Events from "./Events";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import primaryBg from "../../assets/Backgrounds/primaryBg.svg";
import logo from "../../imges/logos/mindsinaction/logo-blog.png";
import AboutSection from "./AboutSection";
import Whysteam from "./Whystean";
import Csr from "./Csr";
import OurCsr from "./OurCsr";
import Billboard from "./BillboardAdds";
import Footer from "./Footer";
import Gallery from "./Gallery";
import TestimonialsPage from "./Testimonials";
import Partners from "./Partners";


const Leave = () => {
  const [stats, setStats] = useState([]);
  const [csr, setCsr] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [testmonial, setTestmonials] = useState([]);
  const [billAdds, setBillAdds] = useState([]);
  const [csrEvent, setCsrEvent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imagebackground, setImageBackground] = useState([]);
  const { getData } = useAuth();
  const [isNewsOpen, setIsNewsOpen] = useState(false);
  const [isEventsOpen, setIsEventsOpen] = useState(false);
  const [websettings, setSettings] = useState([]);
  const [clients, setClients] = useState([]);
  const [partners, setPartners] = useState([]);
  
  const popupRef = useRef(null);
  const newsButtonRef = useRef(null);
  const eventsButtonRef = useRef(null);

  // Fetch data
  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        setError(null);

        const response = await getData("proccess.php", "adverts_V2");
        if (response.success) setBillAdds(response.data);

        const responsePartners = await getData("proccess.php", "our_partners_V2");
        if (responsePartners.success) setPartners(responsePartners.data);

        const responseClints = await getData("proccess.php", "our_clients_V2");
        if (responseClints.success) setClients(responseClints.data);

        const responsewebSet = await getData("proccess.php", "websettings");
        if (responsewebSet.success) setSettings(responsewebSet.data);

        const responseTestmonials = await getData("proccess.php", "testmonials_V2");
        if (responseTestmonials.success) setTestmonials(responseTestmonials.data);

        const responseGallery = await getData("proccess.php", "gallery");
        if (responseGallery.success) setGallery(responseGallery.data);

        const backgroundResponse = await getData("proccess.php", "backgrounds");
        if (Array.isArray(backgroundResponse.data)) {
          setImageBackground(backgroundResponse.data);
        }

        const statsResponse = await getData("proccess.php", "why_steam");
        if (statsResponse.success && Array.isArray(statsResponse.data)) {
          setStats(statsResponse.data);
        }

        const csrResponse = await getData("proccess.php", "csr_V2");
        if (csrResponse.success && Array.isArray(csrResponse.data)) {
          setCsr(csrResponse.data);
        }

        const csrEventResponse = await getData("proccess.php", "csr_events_V2");
        if (csrEventResponse.success && Array.isArray(csrEventResponse.data)) {
          setCsrEvent(csrEventResponse.data);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Failed to load data. Please try again later.");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [getData]);

  // Handle click outside to close popups
  useEffect(() => {
    const handleClickOutside = (event) => {
      // If click is outside popup AND outside both buttons
      if (
        popupRef.current && 
        !popupRef.current.contains(event.target) &&
        !newsButtonRef.current?.contains(event.target) &&
        !eventsButtonRef.current?.contains(event.target)
      ) {
        closePopups();
      }
    };

    // Handle escape key press
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        closePopups();
      }
    };

    // Only add event listeners when popup is open
    if (isNewsOpen || isEventsOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscapeKey);
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscapeKey);
      document.body.style.overflow = 'unset';
    };
  }, [isNewsOpen, isEventsOpen]);

  // Handle popup toggle functions
  const toggleNewsPopup = () => {
    setIsNewsOpen(!isNewsOpen);
    setIsEventsOpen(false);
  };

  const toggleEventsPopup = () => {
    setIsEventsOpen(!isEventsOpen);
    setIsNewsOpen(false);
  };

  const closePopups = () => {
    setIsNewsOpen(false);
    setIsEventsOpen(false);
  };

  // Calculate popup width based on state
  const popupWidth = isNewsOpen || isEventsOpen ? 350 : 30;
  const popupTop = isNewsOpen || isEventsOpen ? 0 : 100;

  if (loading) return <LoadingPage />;

  // if (error) {
  //   return (
  //     <Box minHeight="100vh" display="flex" justifyContent="center" alignItems="center">
  //       <Typography color="error">{error}</Typography>
  //     </Box>
  //   );
  // }

  const backgroundImage = imagebackground[0]?.image
    ? `url(https://mindsinaction.com.na/assets/media/pictures/${imagebackground[0].image})`
    : `url(${primaryBg})`;

  return (
    <Box sx={{ position: 'relative', overflow: 'hidden' }}>
      {/* Backdrop with blur effect */}
      {(isNewsOpen || isEventsOpen) && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
            zIndex: 1000,
            animation: 'fadeIn 0.2s ease-out',
            '@keyframes fadeIn': {
              from: { opacity: 0 },
              to: { opacity: 1 }
            }
          }}
        />
      )}

      {/* Background Image */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: backgroundImage,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: -1,
        }}
      />

      {/* Main Content */}
      <Box>
        <Carousels settings={websettings} />
        
        {/* News/Events Popup Container */}
        <Box
          ref={popupRef}
          sx={{
            position: 'fixed',
            top: `${popupTop}px`,
            right: 0,
            width: {xs: (isNewsOpen || isEventsOpen) ? popupWidth : popupWidth, sm: (isNewsOpen || isEventsOpen) ? "500px" : '30px'},
            height: '100vh',
            zIndex: 1500,
            transition: 'width 0.3s ease',
            overflow: 'hidden',
            borderLeft: (isNewsOpen || isEventsOpen) ? '0.2rem solid orangered' : 'none',
            boxShadow: (isNewsOpen || isEventsOpen) ? 3 : 0,
            backgroundColor: (isNewsOpen || isEventsOpen) ? 'white' : 'transparent',
          }}
        >
          {/* News Button */}
          <Button
            ref={newsButtonRef}
            onClick={toggleNewsPopup}
            sx={{
              width: '80px',
              height: '50px',
              backgroundColor: isNewsOpen ? 'rgba(255, 69, 0, 0.9)' : 'rgba(255, 255, 255, 0.9)',
              transform: 'rotate(90deg)',
              position: 'absolute',
              top: '180px',
              right: '-40px',
              padding: '2rem 0 0 0',
              zIndex: 1000,
              '&:hover': {
                backgroundColor: isNewsOpen ? 'rgba(255, 69, 0, 1)' : 'rgba(255, 255, 255, 1)',
                transform: 'rotate(90deg) scale(1.05)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            <Typography 
              variant="h6" 
              color={isNewsOpen ? 'black' : 'black'} 
              align="center"
              fontWeight={600}
            >
              News
            </Typography>
          </Button>

          {/* Events Button */}
          <Button
            ref={eventsButtonRef}
            onClick={toggleEventsPopup}
            sx={{
              width: '80px',
              height: '50px',
              backgroundColor: isEventsOpen ? 'rgba(255, 69, 0, 0.9)' : 'rgba(255, 255, 255, 0.9)',
              transform: 'rotate(90deg)',
              position: 'absolute',
              top: '300px',
              right: '-40px',
              padding: '2rem 0 0 0',
              zIndex: 1000,
              '&:hover': {
                backgroundColor: isEventsOpen ? 'rgba(255, 69, 0, 1)' : 'rgba(255, 255, 255, 1)',
                transform: 'rotate(90deg) scale(1.05)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            <Typography 
              variant="h6" 
              color={isEventsOpen ? 'black' : 'black'} 
              align="center"
              fontWeight={600}
            >
              Events
            </Typography>
          </Button>

          {/* News Popup Content */}
          {isNewsOpen && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 2500,
                overflowY: 'auto',
                backgroundColor: 'white',
                animation: 'slideInRight 0.3s ease-out',
                '@keyframes slideInRight': {
                  from: { transform: 'translateX(100%)' },
                  to: { transform: 'translateX(0)' }
                }
              }}
            >
              <Box sx={{ padding: '4rem 0', position: 'relative' }}>
                <IconButton
                  onClick={closePopups}
                  sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    color: 'primary.main',
                    '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' }
                  }}
                >
                  <CloseOutlinedIcon />
                </IconButton>
                <News />
              </Box>
            </Box>
          )}

          {/* Events Popup Content */}
          {isEventsOpen && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 2002,
                overflowY: 'auto',
                backgroundColor: 'white',
                animation: 'slideInRight 0.3s ease-out',
              }}
            >
              <Box sx={{ padding: '4rem 0', position: 'relative' }}>
                <IconButton
                  onClick={closePopups}
                  sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    color: 'primary.main',
                    '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' }
                  }}
                >
                  <CloseOutlinedIcon />
                </IconButton>
                <Events />
              </Box>
            </Box>
          )}
        </Box>
      </Box>

      {/* Rest of the sections */}
      <AboutSection ourClients={clients} settings={websettings} />
      <Whysteam Statistics={stats} imagebackground={imagebackground} />
      <Billboard adds={billAdds} />
      <Csr csr={csr} csrEvent={csrEvent} />
      <OurCsr csr={csr} csrEvent={csrEvent} />
      <Gallery gallery={gallery} />
      <TestimonialsPage testimon={testmonial} companyLogo={logo} />
      <Partners PartnerList={partners} />
      <Footer />
    </Box>
  );
};

export default Leave;